import { FC, useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import { Box } from "@mui/material";
import LoadingSpinner from "../LoadingSpinner";

interface Props {
  dataSeries: any;
  loading?: boolean;
}

const Chart: FC<Props> = ({ dataSeries, loading }) => {
  const startY = useMemo(() => {
    const data = dataSeries[0].data;
    const minValue = Math.min(...data.map((item: any) => item[1]));
    return Math.floor(minValue / 100) * 100;
  }, [dataSeries]);

  const options = {
    title: {
      text: "",
    },
    chart: {
      zoomType: "x",
    },
    xAxis: {
      type: "datetime",
      labels: {
        formatter: function (): string {
          return moment.utc((this as any).value).format("MM/DD/YYYY");
        },
      },
    },
    yAxis: {
      title: {
        text: "",
      },
      min: startY,
      startOnTick: false,
      tickmarkOffset: startY,
      tickPositioner: function () {
        return [
          startY,
          ...(this as any).tickPositions.filter(
            (position: number) => position > startY
          ),
        ];
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      // xDateFormat: "%m/%d/%Y",
      // shared: false,
      formatter: function () {
        return `Date:&nbsp;&nbsp;<b>${moment.utc((this as any).x).format(
          "MM/DD/YYYY"
        )}</b><br />Value:&nbsp;<b>${(this as any).y}</b>`;
      },
    },
    credits: {
      enabled: false,
    },
    series: dataSeries,
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", paddingY: 12 }}>
        <LoadingSpinner />
      </Box>
    );
  }

  if (!dataSeries[0]?.data?.length) {
    return (
      <Box sx={{ textAlign: "center", paddingY: 12 }}>
        No chart data available.
      </Box>
    );
  }

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default Chart;
